var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"justify":"center","align-content":"center"}},[_c('div',{staticStyle:{"width":"100%"}},[_c('PackageList'),_c('OptionBook'),_c('UserInterviews')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }